module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2019 by Kate Davies")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Questions for Discussion © 2020 by Houghton Mifflin Harcourt Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("A Conversation with Kate Davies © 2020 by Kate Davies")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Names: Davies, Kate, 1983– author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: In at the deep end / Kate Davies.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: Boston : Houghton Mifflin Harcourt, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2018042560 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2018048398 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328628657 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328629678 (hardback) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-358-29959-2 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Subjects: | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BISAC: FICTION")]), _vm._v(" / Contemporary Women. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / Humorous. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / Lesbian.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("6104."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("8648 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC PR")]), _vm._v("6104."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("8648 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I")]), _vm._v("5 2019 (print) |")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 823/.92—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DC")]), _vm._v("23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2018042560",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018042560")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Cover design by Micaela Alcaino © HarperCollinsPublishers Ltd 2019")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover photograph © Ros Roberts / Getty images")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © Idil Sukan / Hardy Towers")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("v2.0520")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0